<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="seatmap-seat-products-modal-title"
>
  <div #modalHead>
    <span
      id="seatmap-seat-products-modal-title"
      class="u-visually-hidden"
      innerHTML="{{ 'm_static_message-heading.seatType' | staticMsg }}"
    ></span>
    <button
      id="seatmap-products-modal-close"
      class="p-modal-head01__close js-modal-close"
      aswThrottleClick
      (throttleClick$)="close()"
    >
      <span class="u-visually-hidden" innerHTML="{{ 'm_static_message-alt.closeModal' | staticMsg }}"></span>
    </button>
  </div>

  <div #modalBody [class]="[lmodalBodyClass, 'p-modal01__body']">
    <div class="p-modal-body10">
      <div class="p-modal-seatmap-seat-type">
        <!-- 通常席 -->
        <div class="p-modal-seatmap-seat-type__item" *ngIf="normalSeatImage">
          <!-- シートのプロダクトURLが存在する場合 -->
          <a
            *ngIf="normalSeatProductUrl; else normalSeatImageWithoutLink"
            id="seatmap-products-modal-normal-link"
            href="{{ normalSeatProductUrl }}"
            target="_blank"
            class="p-modal-seatmap-seat-type__link p-modal-seatmap-seat-type__link--external"
          >
            <div class="p-modal-seatmap-seat-type__link-title p-modal-seatmap-seat-type__link-title--em">
              <span
                class="p-modal-seatmap-seat-type__link-title-label"
                innerHTML="{{ normalSeatNameStaticMsgKey | staticMsg }}"
              ></span>
              <img
                class="c-text-link-external"
                src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16 }}"
                width="16"
                height="16"
                alt="{{ 'm_static_message-alt.anotherWindow' | staticMsg }}"
              />
            </div>
            <div class="p-modal-seatmap-seat-type__link-contents">
              <img
                src="{{ normalSeatImage }}"
                class="p-modal-seatmap-seat-type__link-img seat-product-modal__img--fix-aspect"
                height="188"
                width="308"
                alt="{{ normalSeatImgAltStaticMsgKey | staticMsg }}"
              />
            </div>
          </a>

          <!-- シートのプロダクトURLが存在しない場合 -->
          <ng-template #normalSeatImageWithoutLink>
            <div class="p-modal-seatmap-seat-type__link-title p-modal-seatmap-seat-type__link-title--em">
              <span
                class="p-modal-seatmap-seat-type__link-title-label"
                innerHTML="{{ normalSeatNameStaticMsgKey | staticMsg }}"
              ></span>
            </div>
            <img
              src="{{ normalSeatImage }}"
              class="p-modal-seatmap-seat-type__link-img seat-product-modal__img--fix-aspect"
              height="188"
              width="308"
              alt="{{ normalSeatImgAltStaticMsgKey | staticMsg }}"
            />
          </ng-template>
        </div>

        <!-- 後ろ向き席 -->
        <div class="p-modal-seatmap-seat-type__item" *ngIf="false">
          <!-- シートのコンテンツリンクが存在する場合 -->
          <a
            *ngIf="rearFacingSeatLink; else rearFacingSeatWithoutLink"
            id="seatmap-products-modal-rear-facing-link"
            href="{{ rearFacingSeatLink }}"
            target="_blank"
            class="p-modal-seatmap-seat-type__link p-modal-seatmap-seat-type__link--external"
          >
            <div class="p-modal-seatmap-seat-type__link-title p-modal-seatmap-seat-type__link-title--em">
              <span
                class="p-modal-seatmap-seat-type__link-title-label"
                innerHTML="{{ 'm_static_message-heading.rearFacingSeat' | staticMsg }}"
              ></span>
              <img
                class="c-text-link-external"
                src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16 }}"
                width="16"
                height="16"
                alt="{{ 'm_static_message-alt.anotherWindow' | staticMsg }}"
              />
            </div>
            <div class="p-modal-seatmap-seat-type__link-contents">
              <img
                src="{{ rearFacingSeatImage }}"
                class="p-modal-seatmap-seat-type__link-img seat-product-modal__img--fix-aspect"
                height="188"
                width="308"
                alt="{{ 'm_static_message-label.rearFacingSeat' | staticMsg }}"
              />
            </div>
          </a>
          <!-- シートのコンテンツリンクが存在しない場合 -->
          <ng-template #rearFacingSeatWithoutLink>
            <div class="p-modal-seatmap-seat-type__link p-modal-seatmap-seat-type__link--external">
              <div class="p-modal-seatmap-seat-type__link-title p-modal-seatmap-seat-type__link-title--em">
                <span
                  class="p-modal-seatmap-seat-type__link-title-label"
                  innerHTML="{{ 'm_static_message-heading.rearFacingSeat' | staticMsg }}"
                ></span>
              </div>
              <div class="p-modal-seatmap-seat-type__link-contents">
                <img
                  src="{{ rearFacingSeatImage }}"
                  class="p-modal-seatmap-seat-type__link-img seat-product-modal__img--fix-aspect"
                  height="188"
                  width="308"
                  alt="{{ 'm_static_message-label.rearFacingSeat' | staticMsg }}"
                />
              </div>
            </div>
          </ng-template>
        </div>

        <!-- カウチ席 -->
        <div class="p-modal-seatmap-seat-type__item" *ngIf="false">
          <!-- シートのコンテンツリンクが存在する場合 -->
          <a
            *ngIf="couchSeatLink; else couchSeatWithoutLink"
            id="seatmap-products-modal-couch-link"
            href="{{ couchSeatLink }}"
            target="_blank"
            class="p-modal-seatmap-seat-type__link p-modal-seatmap-seat-type__link--external"
          >
            <div class="p-modal-seatmap-seat-type__link-title p-modal-seatmap-seat-type__link-title--em">
              <span class="p-modal-seatmap-seat-type__link-title-label">
                <span aria-hidden="true" innerHTML="{{ 'm_static_message-heading.couchSeat' | staticMsg }}"></span>
              </span>
              <img
                class="c-text-link-external"
                src="{{ this.appConstants.IMG.R01_P070_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16 }}"
                width="16"
                height="16"
                alt="{{ 'm_static_message-alt.anotherWindow' | staticMsg }}"
              />
            </div>
            <div class="p-modal-seatmap-seat-type__link-contents">
              <img
                src="{{ couchSeatImage }}"
                class="p-modal-seatmap-seat-type__link-img seat-product-modal__img--fix-aspect"
                height="188"
                width="308"
                alt="{{ 'm_static_message-label.couchSeat' | staticMsg }}"
              />
            </div>
          </a>
          <!-- シートのコンテンツリンクが存在しない場合 -->
          <ng-template #couchSeatWithoutLink>
            <div class="p-modal-seatmap-seat-type__link p-modal-seatmap-seat-type__link--external">
              <div class="p-modal-seatmap-seat-type__link-title p-modal-seatmap-seat-type__link-title--em">
                <span class="p-modal-seatmap-seat-type__link-title-label">
                  <span aria-hidden="true" innerHTML="{{ 'm_static_message-heading.couchSeat' | staticMsg }}"></span>
                </span>
              </div>
              <div class="p-modal-seatmap-seat-type__link-contents">
                <img
                  src="{{ couchSeatImage }}"
                  class="p-modal-seatmap-seat-type__link-img seat-product-modal__img--fix-aspect"
                  height="188"
                  width="308"
                  alt="{{ 'm_static_message-label.couchSeat' | staticMsg }}"
                />
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
